import React from "react";
import {
  Avatar,
  Dropdown,
} from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  ShareAltOutlined
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom"; // Import Link
import { useMainLayout } from './MainLayoutProvider';

export const UserMenu = () => {
  const { user, logout } = useMainLayout();

  const items = [
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: logout,
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Avatar src={user?.avatar} alt={user?.name} className="cursor-pointer">
        {user?.name?.[0] || "U"}
      </Avatar>
    </Dropdown>
  );
};